import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import "./CommentModal.scss";

type CommentType = {
  id: number;
  comment_date: string;
  role: "Partner" | "Admin";
  comment: string;
};

type Props = {
  open: boolean;
  onClose: () => void;
  activityName: string;
  comments: CommentType[];
  onAddComment: (comment: string) => void;
  onEditComment: (id: number) => void;
  onDeleteComment: (id: number) => void;
  onUpdate: (data: any) => void;
};

const CommentModal: React.FC<Props> = ({
  open,
  onClose,
  activityName,
  comments,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" className="comment-modal">
      <DialogTitle className="comment-modal-title">
        <span>Comments : {activityName}</span>
        <button className="close-btn" onClick={onClose} aria-label="Close dialog">
          <Iconography icon="xmark" size={IconographySizes.Small} />
        </button>
      </DialogTitle>

      <DialogContent className="comment-modal-content">
        <label htmlFor="new-comment" className="add-comment-label">Add New Comment</label>
        <span className="char-count">0/500</span>
        <div className="textarea-wrapped">
          <textarea
            id="new-comment"
            className="add-comment-textarea"
            placeholder="comment"
            maxLength={500}
            value=""
            onChange={() => {}}
            disabled
          />
          <div className="add-comment-footer">
            <button
              className="add-comment-btn"
              disabled
              aria-label="Add comment"
            >
              ADD
            </button>
          </div>
        </div>
        <div className="table-wrapper">
          <table className="comments-table" aria-label="Comments table">
            <thead>
              <tr>
                <th>Date and Time</th>
                <th>Posted by</th>
                <th>Comment</th>
                <th style={{ textAlign: "center", width: 100 }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {(comments && comments.length === 0) || comments === undefined ? (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center", padding: "1rem" }}>
                    No comments found
                  </td>
                </tr>
              ) : (
                comments && comments.length && comments.map((c_data: any, index: number) => (
                  <tr key={`${c_data.id}-${index}`}>
                    <td>{c_data.comment_date}</td>
                    <td>{c_data.role}</td>
                    <td>
                      <div className="comment-text">{c_data.comment}</div>
                    </td>
                    <td width={100}>
                      <button
                        className="icon-btn submit"
                        aria-label="Edit comment"
                        disabled
                      >
                        <Iconography icon="pen" size={IconographySizes.Small} />
                      </button>
                      <button
                        className="icon-btn cancel"
                        aria-label="Delete comment"
                        disabled
                      >
                        <Iconography icon="trashCan" size={IconographySizes.Small} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </DialogContent>

      <DialogActions className="comment-modal-actions">
        <Button variant="text" onClick={onClose}>
          CANCEL
        </Button>
        <Button variant="contained" disabled>
          UPDATE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommentModal;